import { jsxs as s, jsx as l } from "react/jsx-runtime";
const f = ({ className: c, width: e = "36", height: o = "36" }) => /* @__PURE__ */ s(
  "svg",
  {
    className: c,
    width: e,
    height: o,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    fill: "none",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          d: "M0 18c0 9.941 8.059 18 18 18s18-8.059 18-18S27.941 0 18 0 0 8.059 0 18Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M24.3 11.588C22.612 9.9 20.362 9 18 9c-4.95 0-9 4.05-9 9 0 1.575.45 3.15 1.238 4.5L9 27l4.725-1.238c1.35.675 2.813 1.125 4.275 1.125 4.95 0 9-4.05 9-9 0-2.362-1.012-4.612-2.7-6.3ZM18 25.425c-1.35 0-2.7-.338-3.825-1.012l-.225-.113-2.813.787.788-2.7-.225-.337c-.787-1.238-1.125-2.588-1.125-3.938 0-4.05 3.375-7.424 7.425-7.424 2.025 0 3.825.787 5.288 2.137 1.462 1.463 2.137 3.262 2.137 5.288 0 3.937-3.262 7.312-7.425 7.312Zm4.05-5.625c-.225-.113-1.35-.675-1.575-.675-.225-.113-.338-.113-.45.113-.112.224-.563.675-.675.9-.113.112-.225.112-.45.112-.225-.113-.9-.337-1.8-1.125-.675-.563-1.125-1.35-1.238-1.575-.112-.225 0-.338.113-.45l.338-.338c.112-.112.112-.224.225-.337.112-.113 0-.225 0-.338 0-.112-.45-1.237-.675-1.687-.113-.338-.338-.338-.45-.338h-.45c-.113 0-.338 0-.563.226-.225.224-.787.787-.787 1.912s.787 2.137.9 2.363c.112.112 1.574 2.475 3.824 3.375 1.913.787 2.25.562 2.7.562.45 0 1.35-.563 1.463-1.012.225-.563.225-1.013.113-1.013-.113-.563-.338-.563-.563-.675Z",
          fill: "#fff"
        }
      )
    ]
  }
);
export {
  f as default
};
